/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCurrency,
    IdentityMelcoModelsCurrencyFromJSON,
    IdentityMelcoModelsCurrencyFromJSONTyped,
    IdentityMelcoModelsCurrencyToJSON,
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsCurrency
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsCurrency {
    /**
     * 
     * @type {Array<IdentityMelcoModelsCurrency>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCurrency
     */
    list: Array<IdentityMelcoModelsCurrency>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCurrency
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCurrency
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsCurrencyFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsCurrency {
    return IdentityMelcoModelsGenericList1MelcoModelsCurrencyFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsCurrency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsCurrencyFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsCurrencyToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsCurrency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsCurrencyToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


